var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowPrev = function SvgArrowPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.8 44.8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M15.8 1c10.9-3.6 23.8 2.8 27.5 13.6 2.8 7.5 1.2 16.5-4.1 22.5-5.3 6.2-14 9-21.9 7.1C8.1 42.2.7 33.7.1 24.3-1 14.1 6 3.9 15.8 1m1.8 21.8c2 2.1 3.9 4.3 6.1 6.1.4-.4 1.2-1 1.7-1.4-1.5-1.6-3.1-3.1-4.6-4.6 1.5-1.6 3-3.2 4.5-4.7l-1.5-1.5c-2.1 2-4.2 4-6.2 6.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#747474",
    d: "M17.6 22.8c2-2.1 4.1-4.1 6.1-6.1l1.5 1.5c-1.5 1.6-3 3.1-4.5 4.7l4.6 4.6c-.4.3-1.2 1-1.7 1.4-2.1-1.8-4-4-6-6.1z"
  })));
};
export default SvgArrowPrev;